import { $ } from 'hanako-ts/dist/Framework';
import { Collection } from 'hanako-ts/dist/Collection';
import { Component } from 'hanako-ts/dist/Component';
import { Pixelator } from '../../components/PageAppear/Appearers/Pixelator';

export class ModuleGallery extends Component {

  constructor() {
    super('ModuleGallery', true);
  }

  public async init(): Promise<void> {
    await super.init();

    $('[data-gallery] a').on(['mouseenter', 'mouseleave'], (event: MouseEvent, link: Collection) => {
      const module = $(link).parents('[data-gallery]');
      const currentId = link.parent().find('canvas').attr('id');

      module.find('canvas').each((canvas: Collection) => {
        if (canvas.attr('id') == currentId) {
          Pixelator.changePixelation(canvas.attr('id'), event.type == 'mouseenter' ? 'full' : 'out');
        }
      });
    });

    this.success();
  }
}
